<div class="form-container">
    <h2>Propiedades del formulario</h2>
    <form [formGroup]="formularioForm" (ngSubmit)="onSubmit()">
      <!-- Campo Nombre -->
      <div class="form-group">
        <label for="Nombre">Nombre</label>
        <input
          id="Nombre"
          type="text"
          formControlName="Nombre"
          placeholder="Ingrese el nombre"
        />
        <small *ngIf="controls['Nombre'].invalid && controls['Nombre'].touched" class="error">
          El nombre es obligatorio y debe tener al menos 3 caracteres.
        </small>
      </div>
  
      <!-- Campo Descripción -->
      <div class="form-group">
        <label for="Descripcion">Descripción</label>
        <textarea
          id="Descripcion"
          formControlName="Descripcion"
          placeholder="Ingrese la descripción"
        ></textarea>
        <small *ngIf="controls['Descripcion'].invalid && controls['Descripcion'].touched" class="error">
          La descripción es obligatoria y debe tener al menos 5 caracteres.
        </small>
      </div>

        <!-- <div *ngIf="id!=null" class="form-group">
        <button mat-raised-button [routerLink]="['/editarformulario/'+id]">Editar Formulario</button>
        </div> -->
    

        <div class="form-group">
            <!-- Botón Guardar -->
            
            <button *ngIf="id==null" type="submit" [disabled]="formularioForm.invalid">Crear formulario</button>
        </div>

      
    </form>
  </div>
  